export default {
  "app-spec": () => import("/app/apps/concierge/src/layouts/app.spec.js").then(m => m.default || m),
  app: () => import("/app/apps/concierge/src/layouts/app.vue").then(m => m.default || m),
  "view-my-claim": () => import("/app/apps/concierge/src/layouts/view-my-claim.vue").then(m => m.default || m)
}